export const FILE_SERVER_APP_PROFILE = 'FILE_SERVER_APP_PROFILE';
export const PROFILE_AISH = 'aish';
export const PROFILE_IES = 'ies';
export const PROFILE_FB = 'fb';
export const PROFILE_FSCD = 'fscd';
